<template>
  <div class="purchaseScreen">
    <div class="purchaseScreen__content">
      <div class="purchaseScreen__heading">
        <h1 class="text-center">
          Continue na frente da concorrência!
        </h1>
        <p class="text-center">
          O período de avaliação terminou, mas ainda dá tempo de assumir o controle da estratégia e ficar na liderança
        </p>
      </div>

      <div class="purchaseScreen__body">
        <p class="purchaseScreen__body-description">
          Conte com o <strong>STILINGUE Benchmarks</strong> para:
        </p>
        <div class="purchaseScreen__body-itens-what">
          <div class="purchaseScreen__body-item">
            <img src="../assets/compare.svg">
            <p>
              <strong>Comparar redes sociais</strong> e ter visibilidade da estratégia de concorrentes
            </p>
          </div>
          <div class="purchaseScreen__body-item">
            <img src="../assets/optimize.svg">
            <p>
              <strong>Otimizar</strong> sua estratégia digital com o que funciona de verdade!
            </p>
          </div>
          <div class="purchaseScreen__body-item">
            <img src="../assets/learn.svg">
            <p>
              <strong>Aprender com insights</strong> valiosos através de engajamento, comunidades e conteúdos
            </p>
          </div>
          <div class="purchaseScreen__body-item">
            <img src="../assets/exit.svg">
            <p>
              <strong>Sair na frente</strong> rumo à liderança no seu segmento!
            </p>
          </div>
        </div>
      </div>

      <div class="purchaseScreen__footer">
        <p class="purchaseScreen__footer-text-helper text-center">
          Chame nosso time de  Customer Success ou converse com a gente no chat para mais informações
        </p>
        <DsButton
          v-if="!showSendEmail"
          class="ds-button ds-button--primary ds-button--medium"
          @click="sendEmail"
        >
          Solicitar contato
        </DsButton>
        <p
          v-if="showSendEmail"
          class="purchaseScreen__footer-send-email text-center"
        >
          Agora é só aguardar que entraremos em contato.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { DsButton } from '@ds/components';
import SendMailBeta from '@/services/SendMailBeta';

import { dispatchMixpanelTrack } from '@/utils';

export default {
  name: 'PurchaseScreen',
  components: {
    DsButton,
  },
  data() {
    return {
      showSendEmail: false,
      date: format(new Date(), 'dd/MM/yyyy'),
      nome: this.$store.state.user.user.name,
      email: this.$store.state.user.user.email,
      userGroup: this.$store.state.user.user.userGroup,
    };
  },
  created() {
    dispatchMixpanelTrack('BM Sales Contact View', [], {
      user_group: this.userGroup,
      email: this.email,
    });
  },
  methods: {
    async sendEmail() {
      dispatchMixpanelTrack('BM Sales Contact Click', [], {
        user_group: this.userGroup,
        email: this.email,
      });

      this.params = {
        'subject': `${this.nome} - ${this.userGroup} - | Interesse de compra BENCHMARKS`,
        'fromEmail': {
          'name': 'Customer Acquisition',
          'email': 'customeracquisition@stilingue.com.br',
        },
        'toEmails': [
          {
            'email': 'customeracquisition@stilingue.com.br',
          },
        ],
        'data': {
          'date': '',
          'title': 'Segue as informações do cliente para Compra do STILINGUE Benchmarks.',
          'paragraph1': `Data de interesse: ${this.date}`,
          'paragraph2': `Nome do cliente: ${this.nome}`,
          'paragraph3': `Email: ${this.email}`,
          'paragraph4': `User group: ${this.userGroup}`,
        },
      };

      await SendMailBeta.sendMail(this.params);
      this.showSendEmail = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.purchaseScreen {
  background: var(--ds-color-background);
  min-width: 100%;
  min-height: calc(100vh - 58px);

  &__content {
    width: 1320px;
    padding-top: var(--ds-spacing-inline-lg);
    margin: 0 auto;
  }

  .strong {
    font-weight: var(--ds-font-weight-semibold);
  }

  &__heading {
    h1 {
      font-style: normal;
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      color: var(--ds-color-text-1);
      margin-bottom: var(--ds-spacing-stack-nano);
    }

    p {
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      color: var(--ds-color-text-2);
      margin-bottom: 0;
    }
  }

  &__body {
    width: 60%;
    margin: var(--ds-spacing-inline-lg) auto;
    text-align: center;

    &-description {
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      color: var(--ds-color-text-1);
    }

    &-itens-what {
      display: grid;
      grid-template-columns: auto auto;
    }

    &-item {
      display: flex;
      align-items: center;
      margin-bottom: var(--ds-spacing-stack-md);
      padding-right: var(--ds-spacing-stack-xs);

      img {
        height: 85px;
        width: 85px;
        margin-right: var(--ds-spacing-stack-xs);
      }

      p {
        color: var(--ds-color-brand-3);
        font-size: var(--ds-font-size-sm);
        margin-bottom: 0;
      }
    }
  }

  &__footer {
    text-align: center;

    &-text-helper {
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      color: var(--ds-color-text-1);
    }

    &-send-email {
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-lg);
      color: var(--ds-color-text-1);
    }
  }
}
</style>
